import React, { useCallback, useState } from "react";
import { AddCrossTinyIcon, CancelCrossIcon, IconButton, Menu } from "@activecollab/components";
import PropTypes from "prop-types";
import { useFileIntegrations } from "../Hooks/useFileIntegrations.jsx";
import { AttachmentMenuList } from "../select_attachments/menu/index.jsx";

export const ChatAttachmentsPicker = ({ openFileWindow, onAttachFromDropbox, onAttachFromGoogleDrive }) => {
  const { hasAttachmentIntegration } = useFileIntegrations();
  const [showMenu, setShowMenu] = useState(false);

  const handleOpenMenu = useCallback(() => {
    setShowMenu(true);
  }, []);
  const handleCloseMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  return hasAttachmentIntegration ? (
    <Menu
      open={showMenu}
      onOpen={handleOpenMenu}
      target={
        <IconButton
          type="button"
          variant="primary"
          className="chat-add-attachment-btn"
        >
          {showMenu ? <CancelCrossIcon /> : <AddCrossTinyIcon />}
        </IconButton>
      }
      onClose={handleCloseMenu}
      mode="tiny"
    >
      <AttachmentMenuList
        onAttachFromDropbox={onAttachFromDropbox}
        onAttachFromGoogleDrive={onAttachFromGoogleDrive}
        onCloseMenu={handleCloseMenu}
        openFileWindow={openFileWindow}
      />
    </Menu>
  ) : (
    <IconButton
      type="button"
      variant="primary"
      className="chat-add-attachment-btn"
      onClick={openFileWindow}
    >
      <AddCrossTinyIcon />
    </IconButton>
  );
};

ChatAttachmentsPicker.propTypes = {
  openFileWindow: PropTypes.func,
  onAttachFromDropbox: PropTypes.func,
  onAttachFromGoogleDrive: PropTypes.func,
};
